document.addEventListener('DOMContentLoaded', function () {
  var exhibition_slic_config = {
    infinite: false,
    dots: true,
    arrows: true,
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3
        },
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1
        },
      },
    ]
  }
  $('.exhibition-wrapper .review-swiper:not(.swiper-hidden)').slick(exhibition_slic_config);
  $('.exhibition-wrapper .nav-wrapper .nav-msg').click(function () {
    if ($('.exhibition-wrapper .nav-wrapper').hasClass('active')) return false;
    var wrapper_dom = $(this).closest('.exhibition-wrapper');
    var index = $(this).attr('data-nav-index');
    var selected_slick = wrapper_dom.find('.review-swiper[data-nav-index="' + index + '"]');

    wrapper_dom.find('.nav-wrapper .nav-msg').removeClass('active').end()
      .find('.review-swiper').addClass('swiper-hidden').end();
    selected_slick.removeClass('swiper-hidden');
    if (!selected_slick.hasClass('slick-initialized')) {
      selected_slick.slick(exhibition_slic_config);
    }
    $(this).addClass('active');
  })
    document.body.addEventListener('click', function (event) {
        if (event.target.closest('.mb-nav-search-input .search-icon')) {
            var search_input = document.querySelector('.mb-nav-search-input input');
            var search_url = search_input.getAttribute('data-search-url');
    
            window.location.href = search_url + '?q=' + search_input.value;
        }
    })

    document.querySelectorAll('.js-collapse').forEach((item) => {
      item.addEventListener('click', function () {
        const greatGrandParent = this.parentElement.parentElement.parentElement;
        const sibling = greatGrandParent.parentElement.querySelector('.t4s-footer-content');

        if (sibling) {
          if (sibling.classList.contains('collapsed')) {
            sibling.classList.remove('collapsed');
            this.classList.add('rotate-animation');
          } else {
            sibling.classList.add('collapsed');
            this.classList.remove('rotate-animation');
          }
        }
      });
    });

    // 处理角标
    const cornerMarkArr = document.querySelector('.egohome-footer').getAttribute('data-corner-marks');

    if (cornerMarkArr) {
      const cornerMarkArrObj = cornerMarkArr.split(',');

      cornerMarkArrObj.forEach((item) => {
        const itemArr = item.split(':');
        if (itemArr.length !== 2) return;
        const menuName = itemArr[0].trim();
        const cornerMark = itemArr[1].trim();

        document.querySelectorAll('.t4s-footer-link').forEach((link) => {
          const linkText = link.textContent.trim();
          if (linkText === menuName) {
            const span = document.createElement('span');
            span.className = 'corner-mark';
            span.textContent = cornerMark;

            link.appendChild(span);
          }
        });
      });
    }
  });